import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';

import { HomePage } from '../pages/home/home';
import { FacilityPage } from "../pages/facility/facility";
import { UnitPage } from "../pages/unit/unit";
import { ArticlePage } from "../pages/article/article";
import { SettingPage } from "../pages/setting/setting"

import { LoginPage } from "../pages/login/login";

import { GooglePlus } from "@ionic-native/google-plus";

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    FacilityPage,
    UnitPage,
    ArticlePage,
    SettingPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    FacilityPage,
    UnitPage,
    ArticlePage,
    SettingPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    GooglePlus
  ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts